import { useLazyQuery } from '@apollo/client/react/hooks'
import { useCallback } from 'react'
import { ContentPolicyListYIQuery } from './ContentPolicyListYIQuery'
import { extractContentPolicyId } from './extractContentPolicyId'

export function useLazyFetchYIContentPolicyId () {
  const [fetchYIContentPolicyIdBase, rawResult] = useLazyQuery(ContentPolicyListYIQuery)

  const fetchYIContentPolicyId = useCallback(async () => {
    const result = await fetchYIContentPolicyIdBase()
    const rawPolicyId = extractContentPolicyId(result.data)
    return rawPolicyId
  }, [fetchYIContentPolicyIdBase])

  return [fetchYIContentPolicyId, rawResult] as const
}
